<template>
  <div class="content" style="height: calc(100% - 96px);">
    <h2 class="pageHeader">角色管理</h2>
    <div class="role flex">
      <div class="flex-l">
        <div class="p-title">角色列表 <el-button round @click="handleAdd()" size="mini" class="btn_r">添加</el-button></div>
        <el-scrollbar style="height: calc(100% - 50px);">
          <div style="padding:0 8px;">
            <el-menu default-active="1" class="el-menu-vertical-demo">
              <template>
                <el-menu-item v-for="item in $store.state.posts" :key="item.value" :index="item.value + ''"
                  @click="handleClick(item.value)">
                  <i class="el-icon-menu"></i>
                  <span slot="title" style="width:100%;display: inline-block;">{{ item.label }}
                    <div class="btn_r" style="top:0;">
                      <el-button type="text" @click.stop="handleEdit(item)" size="mini">
                        编辑</el-button><el-button type="text" v-if="item.value > 100"
                        @click.stop="handleDelete(item.value)" size="mini">
                        删除</el-button>
                    </div>
                  </span>
                </el-menu-item>
              </template>
            </el-menu>
          </div>
        </el-scrollbar>
      </div>
      <div class="flex-r" style="margin-right: 8px;">
        <div class="p-title">角色权限设置 <el-button round @click="getCheckedKeys" size="mini" class="btn_r">设置权限</el-button>
        </div>
        <!-- <div style="padding:24px;overflow: auto;"> -->
        <el-scrollbar style="height: calc(100% - 50px);">
          <div style="padding:24px;">
            <el-tree :data="treeArr" ref="tree" node-key="index" highlight-current show-checkbox default-expand-all
              :props="defaultProps">
            </el-tree>
          </div>
        </el-scrollbar>
        <!-- </div> -->
      </div>
      <div class="flex-r">
        <div class="p-title">角色权限展示</div>
        <el-scrollbar style="height: calc(100% - 50px);">
          <div style="padding:24px;">
            <el-tree :data="currentMenu" ref="tree1" node-key="index" highlight-current default-expand-all
              :props="defaultProps">
            </el-tree>
          </div>
        </el-scrollbar>

      </div>
      <el-dialog :close-on-click-modal="false" title="添加角色" :visible.sync="centerDialogVisible" width="386px">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="角色名称" prop="name">
            <el-input v-model="ruleForm.name" placeholder="请输入角色名称" style="width:216px;"></el-input>
          </el-form-item>
          <el-form-item style="margin-top:8px;width:100%;text-align:right;">
            <el-button type="primary" v-if="type == 'add'"
              @click="submitFormByFun('ruleForm', createMethod)">确认</el-button>
            <el-button type="primary" v-if="type == 'edit'"
              @click="submitFormByFun('ruleForm', updateMethod)">编辑</el-button>
            <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- <div>
        <el-button @click="getCheckedNodes">通过 node 获取</el-button>
        <el-button @click="getCheckedKeys">通过 key 获取</el-button>
        <el-button @click="setCheckedNodes">通过 node 设置</el-button>
        <el-button @click="setCheckedKeys">通过 key 设置</el-button>
      </div> -->

      <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="30%"
        :before-close="handleClose">
        <span>是否要设置该角色权限</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="addRoleMenu">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: 'roleManage',
  data() {
    return {
      defaultProps: {
        children: 'childs',
        label: 'title',
      },
      loading: true,
      type: 'add',
      roles: [
        { id: 1, name: '管理员' },
        { id: 2, name: '授课老师' },
        { id: 3, name: '实训老师' },
        { id: 4, name: '学生' },
        { id: 5, name: '超级管理员' },
      ],
      ruleForm: {
        name: '',
      },
      rules: {
        name: [{ required: true, message: '请输入角色名称', trigger: 'blur' }],
      },
      centerDialogVisible: false,
      dialogVisible: false,
      treeArr: [],
      setArr: [],
      bothArr: [],
      schoolid: null,
      roleid: 1,
      currentMenu: [],
      checkNodes: [],
      menuid: null,
    };
  },
  components: {},
  async created() {
    // 公共菜单数据对接：从接口 api/menu/setting/list 获取（见 store action getMenuItems）
    await this.$store.dispatch('getMenuItems');
    this.treeArr = this.$store.getters.menuItems;
    this.schoolid = this.$store.state.userInfo.schoolid;

    // this.roleid = this.$store.state.userInfo.id;
    this.getRoleMenu(1);
  },
  computed: {
    checkedMenu() {
      let att = [];
      if (this.currentMenu.length) {
        this.currentMenu;
      }
      return att;
    },
  },
  mounted() {
    // this.getStudentApply()
    // this.getProvince()
    this.$store.dispatch('getPosts');
  },
  methods: {
    handleClick(id) {
      this.roleid = id;
      this.getRoleMenu(id);
    },
    getCheckNodes(arr) {
      arr.map((item) => {
        if (item.childs) {
          this.getCheckNodes(item.childs);
        } else {
          this.checkNodes.push(item.index);
        }
      });
    },
    handleAdd() {
      this.ruleForm = {
        name: ''
      }
      this.type = 'add'
      this.centerDialogVisible = true
    },
    handleEdit(row) {
      this.type = 'edit'
      this.ruleForm = {
        id: row.value,
        name: row.label
      }
      this.centerDialogVisible = true
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);
      let res = await this.$api.instance.interfaceServer(`api/role/edit/${this.ruleForm.id}`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.instance.interfaceServer('api/role/add', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '添加成功！',
        });
        this.clearState();
      }
    },

    clearState() {
      this.resetForm('ruleForm')
      this.ruleForm = {
        name: ''
      }
      this.centerDialogVisible = false;
      this.$store.dispatch('getPosts');
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    submitFormByFun(formName, $fun) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          $fun()
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose() {
      this.dialogVisible = false;
    },
    handleDelete(id) {
      this.confirmBox('warning', `此操作将删除该角色，是否继续`, { id }, this.deleteMethod);
    },
    confirmBox(type, title, params, $fun) {
      this.$confirm(title, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: type,
      })
        .then(() => {
          $fun(params)
        })
        .catch(() => {
        });
    },
    async deleteMethod(params) {
      let res = await this.$api.instance.interfaceServer(`api/role/delete/${params.id}`, 'post', {});
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
      }
      this.$store.dispatch('getPosts');
    },
    async getRoleMenu(id, isSet = false) {
      let res = await this.$api.instance.queryRoleMenu({ role: id });
      this.loading = false;
      if (res.code == 0 && res.data && res.data.id) {
        this.menuid = res.data.id;
        this.checkNodes = [];
        this.currentMenu = JSON.parse(res.data.menu);
        this.getCheckNodes(this.currentMenu);
        this.setCheckedKeys();
        if (res.data.role_id == this.$store.state.userInfo.usertype && isSet) {
          this.$store.commit('setMenu', res.data.menu);
        }
      } else {
        this.menuid = null;
        this.checkNodes = [];
        this.currentMenu = [];
        this.setCheckedKeys();
      }
      // console.log(res);
    },
    async addRoleMenu() {
      let params = {
        menu: JSON.stringify(this.setArr),
        school_id: this.schoolid,
        role_id: this.roleid,
      };
      // console.log(params);
      // return;
      if (!this.menuid) {
        let res = await this.$api.instance.addRoleMenu(params);
        if (res.code == 0) {
          this.handleClose();
          this.$message.success('设置成功');
          this.getRoleMenu(this.roleid, true);
        }
      } else {
        // params.id = this.menuid
        let res = await this.$api.instance.updateRoleMenu(this.menuid, params);
        if (res.code == 0) {
          this.$message.success('设置成功');
          this.handleClose();
          this.getRoleMenu(this.roleid, true);
        }
      }

      // console.log(res)
    },
    getCheckedNodes() {
      console.log(
        JSON.stringify(
          this.$refs.tree.getCheckedNodes().map((item) => {
            return item.index;
          })
        )
      );
      // console.log(this.$refs.tree.getCheckedNodes(false, true));
    },
    getCheckedKeys() {
      var arr1 = this.$refs.tree.getCheckedKeys();
      var arr2 = this.$refs.tree.getHalfCheckedKeys();
      this.bothArr = arr1.concat(arr2);
      this.setArr = [];
      this.setMenuArr(this.treeArr, null);
      this.dialogVisible = true;
    },
    setMenuArr(arr, index) {
      // let obj
      arr.map((item) => {
        this.bothArr.map((val) => {
          if (item.index == val && item.childs) {
            let obj = {
              index: item.index,
              title: item.title,
              icon: item.icon,
              module: item.module,
              childs: [],
            };
            this.setArr.push(obj);
            this.setMenuArr(item.childs, this.setArr.length - 1);
          } else if (item.index == val && item.level == 1 && item.path) {
            this.setArr.push(item);
          } else {
            if (this.setArr[index]) {
              if (item.index == val && item.index != 1) {
                this.setArr[index].childs.push(item);
              }
            }
          }
        });
      });
    },
    setCheckedKeys() {
      this.$refs.tree.setCheckedKeys(this.checkNodes);
    },
    setCheckedNodes() {
      this.$refs.tree.setCheckedNodes([
        {
          id: 5,
          label: '二级 2-1',
        },
        {
          id: 9,
          label: '三级 1-1-1',
        },
      ]);
    },
  },
};
</script>
<style lang="less" scoped>
.role {
  height: calc(100% - 72px);
}

.content {
  height: calc(100vh - 120px) !important;
  padding-bottom: 0;
}

.btn_r {
  position: absolute;
  right: 8px;
  top: 11px;
}

// .flex-l{
//   overflow: auto;
// }

/deep/.el-menu-item {
  color: #515254;
}

/deep/.el-menu-item i {
  color: #515254;
}

/deep/.el-menu-item.is-active {
  color: #466a80;
  background: #99b6da;
}

/deep/ .el-menu-item.is-active i {
  color: #466a80;
}

/deep/.el-button--small {
  font-weight: normal;
}

/deep/.el-menu-item:focus,
.el-menu-item:hover {
  background-color: #aac7ea;
}

/deep/.el-tree {
  background: transparent;
}

.flex {
  display: flex;

  &-l {
    width: 350px;
    background: #fff;
    margin-right: 8px;
    border: 2px #c4d8f1 solid;
    box-sizing: border-box;

    .role-ul {
      list-style: none;

      li {
        font-size: 14px;
        text-align: center;
      }
    }
  }

  &-r {
    flex: 1;
    border: 2px #c4d8f1 solid;
    overflow: auto;
  }

  .p-title {
    text-align: center;
    color: #e8e8e8;
    font-size: 15px;
    font-weight: 600;
    background: #4578ed;
    height: 50px;
    line-height: 50px;
    position: relative;
  }
}
</style>
